export default class Share {
    constructor() {
        this.events()
    }

    events() {
        // Web Share API para dispositivos móviles
        const shareButton = document.querySelector('#share-btn');
        if (shareButton) {
            if ('share' in navigator) {
                shareButton.addEventListener('click', (e) => {
                    e.preventDefault()
                    const _title = shareButton.dataset.title
                    const _url = shareButton.dataset.url
                    navigator.share({
                        title: "LacedUpMx",
                        text: _title,
                        url: _url
                    })
                })
            }
        }

        // Manejar enlaces de compartir en redes sociales
        const shareLinks = document.querySelectorAll('.share-link');
        shareLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                
                const platform = link.dataset.platform;
                if (platform === 'copy') {
                    e.preventDefault(); // Siempre prevenir el comportamiento por defecto
                    this.copyLinkHandler(e);
                } else {
                    // Para otras redes sociales, abrir en nueva ventana
                    // El href ya está configurado en el HTML
                    this.trackShare(platform);
                    e.stopPropagation(); // Evitar que el evento se propague
                }
            });
        });
    }

    copyLinkHandler(e) {
        e.preventDefault()
        const url = e.target.dataset.url || e.target.closest('[data-url]')?.dataset.url || window.location.href;

        // Usar Clipboard API si está disponible
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(() => {
                this.showCopyFeedback(e.target);
            }).catch(err => {
                console.error('Error al copiar: ', err);
                this.fallbackCopy(url);
            });
        } else {
            this.fallbackCopy(url);
        }
    }

    fallbackCopy(text) {
        let textArea = document.createElement("textarea")
        textArea.value = text
        textArea.style.position = "fixed"
        textArea.style.left = "-999999px"
        textArea.style.top = "-999999px"
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
            document.execCommand('copy')
            this.showCopyFeedback(document.querySelector('[data-platform="copy"]'));
        } catch (err) {
            console.error('Error al copiar: ', err)
        }

        document.body.removeChild(textArea)
    }

    showCopyFeedback(element) {
        const icon = element.querySelector('i');
        const originalClass = icon.className;

        // Cambiar el ícono temporalmente
        icon.className = 'fa-solid fa-check';

        // Mostrar tooltip o notificación
        this.showNotification();
        // Restaurar el ícono después de 2 segundos
        setTimeout(() => {
            icon.className = originalClass;
        }, 2000);
    }

    showNotification() {
        gsap.to('#share-notification-container', {
            display: 'block',
            duration: 0.3,
            ease: 'power2.inOut'
        });
        setTimeout(() => {
            gsap.to('#share-notification-container', {
                display: 'none',
                duration: 0.3,
                ease: 'power2.inOut'
            });
        }, 3000);
    }

    trackShare(platform) {
        // Aquí puedes agregar analytics para trackear los shares
        console.log(`Compartido en: ${platform}`);

        // Ejemplo con Google Analytics (si está disponible)
        if (typeof gtag !== 'undefined') {
            gtag('event', 'share', {
                method: platform,
                content_type: 'page',
                item_id: window.location.pathname
            });
        }
    }
}